/* eslint-disable  react/display-name*/
import { Grid, IconButton, Tooltip, Typography, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PCheck from "../../components/pos/PCheck";
import PText from "../../components/pos/PText";
import db from "../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { SaleUtils } from "../../utils/SaleUtils";
import { StringUtils } from "../../utils/StringUtils";
import API from "../../utils/API";
import Popover from "@mui/material/Popover";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

export default function KitItems(props) {
  const { t } = useTranslation();
  const translate = t;
  const [prodLookupValue, setProdLookupValue] = useState();
  const [summaryViewOpen, setSummaryViewOpen] = useState(false);
  const [totalCost, setTotalCost] = useState();
  const [costingMethods, setCostingMethods] = useState();
  const [product, setProduct] = useState([]);

  const formatOptionLabel = (option, { context }) => {
    if (context === "menu") {
      return (
        <Grid container>
          <Grid item xs={3}>
            {option.value.unitType}
          </Grid>
          <Grid item xs={6}>
            {option.value.name}
          </Grid>
          <Grid item xs={3}>
            {option.value.price}
          </Grid>
        </Grid>
      );
    }
    if (!option.label) return "";
    return option.label.name;
  };

  const getOptions = (inputValue, callback) => {
    getOptionsAsync(inputValue, callback);
  };

  async function calculations() {
    setTotalCost(0.0);
    let stockList;
    let data = [];
    let total = 0;
    let cost = 0;
    let quantity = 0;
    let costMethod = await SaleUtils.getStoreCostingMethodeCode();
    setCostingMethods(costMethod);

    for (let d of props.kitItemsList) {
      {
        try {
          let { data } = await API.get(
            "/api/v1/stock/" + d[6].info.productBean.stockBean.$id
          );
          stockList = data;
        } catch (err) {
          if (err.response && err.response.status == 404) {
            props.showMessage("warning", translate("No batches found!"));
          } else {
            props.showMessage(
              "error",
              translate("Not able to retrive batch info from server")
            );
          }
        }
      }
      quantity = parseFloat(d[5].v * d[6].info.pricingBean.factor);
      cost = await SaleUtils.getProductCostFromBatchWithQty(
        stockList.stockBatchList,
        costMethod,
        parseFloat(d[6].info.pricingBean.cost / d[6].info.pricingBean.factor),
        quantity,
        props.context,
        props.context.store.currencyDecimal
      );
      setTotalCost((total = total + parseFloat(cost * quantity)));
      let i = [
        {
          name: d[1].v,
          baseQuantity: quantity.toFixed(3),
          uom: d[2].v,
          cost: cost * quantity,
          quantity: d[5].v,
        },

        ,
      ];
      data.push(i);
    }
    setProduct(data);
  }

  const handleClose = () => {
    setSummaryViewOpen(!summaryViewOpen);
  };

  async function getOptionsAsync(inputValue, callback) {
    //JOSE THO
    let dbData = await db.product
      .where("name")
      .startsWithIgnoreCase(inputValue)
      .or("code")
      .startsWithIgnoreCase(inputValue)
      .or("barcodeList")
      .equals(inputValue)
      .limit(10)
      .toArray();

    let arr = [];
    let count = 0;
    for (let i = 0; i < dbData.length; i++) {
      for (let j = 0; j < dbData[i].productPricingBeanList.length; j++) {
        if (count < 10) {
          let val = {
            id: dbData[i].id,
            name: dbData[i].name,
            code: dbData[i].code,
            price: dbData[i].productPricingBeanList[j].price,
            unitType: dbData[i].productPricingBeanList[j].unitType,
            factor: dbData[i].productPricingBeanList[j].factor,
            bean: dbData[i],
            pricingBean: dbData[i].productPricingBeanList[j],
          };
          arr.push(val);
          count++;
        } else {
          break;
        }
      }
    }

    return callback(
      arr.map(function (option, index) {
        return {
          value: option,
          label: option,
        };
      })
    );

    //return callback([]);
  }

  const productLookupChanged = (newValue) => {
    addProductToTable(newValue.value.bean, newValue.value.pricingBean);
    setProdLookupValue({ label: null, value: null });
  };

  function addProductToTable(productBean, pricingBean) {
    var data = [...props.kitItemsList];
    //let itemIndex = getItemIndex(productBean.id, data);

    //console.log("Data Set", data);
    /*if (itemIndex != null && isConsolidated) {
      updatePurchaseItemQty(data, itemIndex, 1);
    } else {*/
    let barcodes = null;
    pricingBean.productBarcodeBeanList.map((item) => {
      if (barcodes == null) barcodes = item.barcode;
      else barcodes = barcodes + "," + item.barcode;
    });

    let sn = data.length + 1;

    let orderItem = [
      { v: sn },
      { v: productBean.name },
      { v: pricingBean.unitType },
      { v: productBean.code },
      { v: barcodes },
      { v: 1 },
      {
        info: {
          productBean: productBean,
          pricingBean: pricingBean,
        },
      },
      { id: null },
    ];
    data.push(orderItem);
    props.setKitItemsList(data);
    // }
  }

  function onRemoveItemClicked(tableMeta, updateValue, value) {
    let data = [...tableMeta.tableData];
    data.splice(tableMeta.rowIndex, 1);
    props.setKitItemsList(data);
  }

  function updateData(eventSource, meta, value, index) {
    let dat = [...props.kitItemsList];
    dat[meta.rowIndex][5].v = value.v;
    props.setKitItemsList(dat);
  }

  const columns = [
    {
      name: "serialNumber",
      label: translate("SN"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 30 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "productName",
      label: translate("Product Name"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 200 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "unit",
      label: "Unit",
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 60 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "productCode",
      label: translate("Product Code"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 60 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "barcode",
      label: translate("Barcode"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 60 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "qty",
      label: translate("Quantity"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 140 }}>
            <PText
              value={value.v}
              type="number"
              onChange={(e) =>
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "action",
      label: translate("Action"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ textAlign: "left" }}>
            {/* <Tooltip title={translate("Remove Item")}>
              <IconButton
                color="secondary"
                onClick={() =>
                  onRemoveItemClicked(tableMeta, updateValue, value)
                }
              >
                <CloseIcon />
              </IconButton>
            </Tooltip> */}

            <Button
              onClick={() => onRemoveItemClicked(tableMeta, updateValue, value)}
              color="secondary"
              style={{
                margin: 0,
                padding: 0,
                height: 17,
                width: 27,
                alignText: "right",
              }}
            >
              {translate("REMOVE")}
            </Button>
          </div>
        ),
      },
    },
  ];

  const options = {
    filterType: null,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    pagination: false,
    selectableRows: "false",
    selectableRowsHeader: true,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: 450,
  };

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <table width="100%">
            <tbody>
              <tr>
                <td width="80%">
                  <AsyncSelect
                    formatOptionLabel={formatOptionLabel}
                    components={{ formatOptionLabel }}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 99999,
                      }),
                      marginRight: "10px",
                    }}
                    placeholder="Product Lookup"
                    loadOptions={getOptions}
                    onChange={productLookupChanged}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                      e.nativeEvent.stopImmediatePropagation();
                    }}
                    value={prodLookupValue}
                    //options={cities}
                  />
                </td>
                <td>
                  <PCheck
                    onChange={(value) => props.setIsExpandOnSale(value)}
                    checked={props.isExpandOnSale}
                    label="Expand kit items on Sale"
                  ></PCheck>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Grid item xs={12} sm={12}>
          <MUIDataTable
            data={props.kitItemsList}
            columns={columns}
            options={options}
          />
        </Grid>
      </Grid>
      <Grid>
        <Tooltip title={"Costing Details"}>
          <IconButton
            style={{ marginRight: "15%" }}
            color="primary"
            onClick={(event) => {
              calculations();
              setSummaryViewOpen(true);
            }}
          >
            <InfoOutlinedIcon />
          </IconButton>
        </Tooltip>
        <Popover
          open={summaryViewOpen}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "center",
            horizontal: Number(50),
          }}
        >
          <Card style={{ marginTop: 5 }}>
            <CardContent style={{ backgroundColor: "#f5f4f2" }}>
              <Typography
                variant="body1"
                style={{
                  textAlign: "center",
                }}
              >
                <b>{translate("Costing Details")}</b>
              </Typography>
              <table width="100%">
                <tbody>
                  <tr>
                    <td>{translate("Costing Method")}</td>
                    <td>:</td>
                    <td
                      style={{
                        paddingLeft: "35px",
                      }}
                    >
                      {costingMethods}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table
                style={{
                  width: "100%",
                  border: "1px solid black",
                  borderCollapse: "collapse",
                }}
              >
                <tbody>
                  <tr>
                    <th
                      style={{
                        border: "1px solid black",
                        borderCollapse: "collapse",
                        textAlign: "left",
                      }}
                    >
                      Item
                    </th>
                    <th
                      style={{
                        border: "1px solid black",
                        borderCollapse: "collapse",
                        textAlign: "left",
                        paddingRight: "20px",
                      }}
                    >
                      Unit Type
                    </th>
                    <th
                      style={{
                        border: "1px solid black",
                        borderCollapse: "collapse",
                        textAlign: "right",
                        paddingLeft: "20px",
                      }}
                    >
                      * Quantity
                    </th>
                    <th
                      style={{
                        border: "1px solid black",
                        borderCollapse: "collapse",
                        textAlign: "right",
                        paddingLeft: "20px",
                      }}
                    >
                      Unit Cost
                    </th>
                  </tr>
                  {product.map(
                    (item) =>
                      item && (
                        <tr>
                          <td
                            style={{
                              textAlign: "left",
                              border: "1px solid black",
                              borderCollapse: "collapse",
                              paddingRight: "20px",
                            }}
                          >
                            {item[0].name}
                          </td>
                          <td
                            style={{
                              textAlign: "left",
                              border: "1px solid black",
                              borderCollapse: "collapse",
                              paddingRight: "20px",
                            }}
                          >
                            {item[0].uom}
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              border: "1px solid black",
                              borderCollapse: "collapse",
                            }}
                          >
                            {item[0].baseQuantity}
                          </td>

                          <td
                            style={{
                              textAlign: "right",
                              border: "1px solid black",
                              borderCollapse: "collapse",
                              paddingLeft: "11px",
                            }}
                          >
                            {StringUtils.formattedNumber(
                              item[0].cost,
                              props.context.store.currencyDecimal
                            )}
                          </td>
                        </tr>
                      )
                  )}
                  <tr>
                    <td
                      style={{
                        textAlign: "center",
                        paddingLeft: "15px",
                        border: "1px solid black",
                        borderCollapse: "collapse",
                      }}
                      // rowSpan={1}
                    >
                      <b>Total Derived Cost</b>
                    </td>

                    <td
                      style={{
                        textAlign: "right",
                        border: "1px solid black",
                        borderCollapse: "collapse",
                      }}
                      colSpan={4}
                    >
                      <b>
                        {StringUtils.formattedNumber(
                          totalCost,
                          props.context.store.currencyDecimal
                        )}
                      </b>
                    </td>
                  </tr>
                </tbody>
              </table>
              <Typography
                variant="body1"
                style={{
                  textAlign: "right",
                  fontWeight: "300",
                }}
              >
                *{translate("Quantity in base unit")}
              </Typography>
            </CardContent>
          </Card>
        </Popover>
      </Grid>
    </div>
  );
}
